export default __webpack_public_path__ + "static/media/img-guide-01@2x.f0d9fa9b.png";